export enum TaskSectionType {
  Container = 'Container',
  Identifier = 'Identifier',
  Info = 'Information',
  Priority = 'Priority',
  Title = 'Title',
  Description = 'Description',
  Location = 'Location',
  Photos = 'Photos',
  Signatures = 'Signatures',
  Documents = 'Documents',
  StarRating = 'StarRating',
}
